import * as React from "react";

interface GenSidebarContainerProps {
  children: React.ReactNode;
}

export default function GenSidebarContainer(props: GenSidebarContainerProps) {
  const {
    children,
  } = props;

  return (
    <div className="gen-sidebar-list">
      {children}
    </div>
  );
}
